export const DATE_KEY_FORMAT = 'yyyy-MM-dd';
export const CALENDAR_RANGE_YEARS = 2;
export const PRIDE_MONTH = 5; // June

export const MONTHS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];
